// extracted by mini-css-extract-plugin
module.exports = {"quill":"styles_quill__2QGpF","mobileInput":"styles_mobileInput__1aXpZ","boxComment":"styles_boxComment__3me_A","commentOptions":"styles_commentOptions__2yi_z"};